// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T22:22:17.383Z
// Property: Bristol Square (ID: 6767906449167178)
// Collections: 9 amenities, 3 floorplans (live), 20 photos, 65 POIs, 2 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167178",
  "property_external_id": "785473",
  "property_zillow_url": "https://www.zillow.com/apartments/colorado-springs-co/bristol-square/5XhvS7/",
  "property_apartments_url": "https://www.apartments.com/bristol-square-colorado-springs-co/pdym5jv/",
  "property_google_business_url": "https://www.google.com/maps/place/Bristol+Square/data=!4m2!3m1!1s0x0:0x207490238e5cf9f8?sa=X&ved=2ahUKEwiEmOut64OTAxUfMVkFHYvoKdEQ_BJ6BAgZEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47611881616",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "bristol-square",
  "property_name": "Bristol Square",
  "property_website_url": "https://www.bristolsquareapartments.com",
  "property_domain": "https://www.bristolsquareapartments.com",
  "property_address": "1506 Yuma St",
  "property_full_address": "1506 Yuma St, Colorado Springs, CO 80909",
  "property_address_1": "1506 Yuma St",
  "property_address_2": null,
  "property_address_city": "Colorado Springs",
  "property_address_state": "CO",
  "property_address_zip_full": "80909",
  "property_address_zip": "80909",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "East Colorado Springs",
  "property_address_latitude": "38.8545612",
  "property_address_longitude": "-104.7776305",
  "property_email": "bristolsquare@weidner.com",
  "property_phone": "7196314197",
  "property_call_tracking_phone": "719-426-3524",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Bristol Square in Colorado Springs, CO, comfort meets convenience with thoughtfully designed studio, one-bedroom, and two-bedroom apartments. Enjoy essential amenities like air conditioning, electric heating, and spacious linen closets, ensuring your living experience is both cozy and functional. Secure your future; explore our availability and schedule a tour today!",
  "property_long_description": "**Welcome to Bristol Square – Your Ideal Colorado Springs Home!**\n\nDiscover the perfect blend of comfort and convenience at Bristol Square, a premier apartment community located in the heart of Colorado Springs, CO. Our thoughtfully designed floor plans cater to a variety of lifestyles, featuring stylish studio, one-bedroom, and two-bedroom apartments that are ideal for singles, couples, or families. Maximize your living experience by exploring all our available options today!\n\nAt Bristol Square, we prioritize your comfort with a host of modern amenities. Each apartment comes equipped with essential features such as efficient garbage disposal and reliable electric heating, ensuring a hassle-free living experience. Enjoy the soothing embrace of baseboard heat or bask in the refreshing coolness of air conditioning*, perfect for those warm Colorado days. With linen closets providing ample storage, you'll have plenty of room for all your essentials.\n\nExperience the vibrant lifestyle of Colorado Springs while enjoying the peace and security of a well-maintained community. Our friendly staff is always here to assist, making your transition to Bristol Square seamless and enjoyable.\n\nDon’t miss your chance to call Bristol Square home! Whether it's discovering your perfect floor plan or getting a firsthand look at our welcoming community, we invite you to browse our availability or schedule a tour today. Your dream apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-7948-70dd-8b6d-02be0e2dccda.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living room with a sectional sofa, coffee table, and large windows.",
    "public_id": "019d021c-7948-70dd-8b6d-02be0e2dccda",
    "storage_key": "property/6767906449167178/019d021c-7948-70dd-8b6d-02be0e2dccda.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "54",
  "property_year_built": "1964",
  "property_year_renovated": null,
  "property_walk_score": "73",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.44444444444444",
  "property_admin_fee": "200",
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security deposit: $500 (refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/bristol-square/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/bristol-square/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/bristol-square/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-cbbc-778c-a8db-1c4d25b38396.webp",
  "property_primary_logo_media": {
    "alt_text": "Bristol Square Apartment Homes logo",
    "public_id": "019d021c-cbbc-778c-a8db-1c4d25b38396",
    "storage_key": "property/6767906449167178/019d021c-cbbc-778c-a8db-1c4d25b38396.webp",
    "width": 1836,
    "height": 687
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-ea7a-76f7-a4ff-c3487754475f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Bristol Square Apartment Homes logo",
    "public_id": "019d021c-ea7a-76f7-a4ff-c3487754475f",
    "storage_key": "property/6767906449167178/019d021c-ea7a-76f7-a4ff-c3487754475f.webp",
    "width": 1836,
    "height": 687
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021e-c7ee-7528-833f-758745dedbe6.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Bristol Square Apartment Homes logo",
    "public_id": "019d021e-c7ee-7528-833f-758745dedbe6",
    "storage_key": "property/6767906449167178/019d021e-c7ee-7528-833f-758745dedbe6.webp",
    "width": 640,
    "height": 239
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#292725",
  "property_secondary_color": "#DED9D4",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#524F4C",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 805",
  "property_sqft_min": "805",
  "property_sqft_max": "806",
  "property_price_range": "824 - 1635",
  "property_price_min": "990",
  "property_price_max": "1580",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/BristolSquareApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/bristolsquareapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ4TNN5pRFE4cR-PlcjiOQdCA",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Bristol Square Apartments",
  "property_home_romance_title": "Get to know your new neighborhood",
  "property_home_amenities_blurb": "Welcome to Bristol Square in beautiful Colorado Springs, CO, where modern living meets comfort. Choose from spacious studio, one-bedroom, or two-bedroom layouts, each equipped with essential amenities like air conditioning and garbage disposal. Embrace a lifestyle of convenience in a community designed to elevate your everyday experience. ",
  "property_home_floorplans_blurb": "Welcome to Bristol Square in beautiful Colorado Springs, where comfort meets style. Our diverse floor plans invite you to embrace a life of modern convenience and captivating mountain views. Browse our available apartment homes today and uncover the perfect space that reflects your unique lifestyle. Your ideal retreat awaits!",
  "property_home_gallery_blurb": "At Bristol Square in Colorado Springs, CO, imagine your ideal home with thoughtfully designed studio, one, and two-bedroom floor plans. Enjoy modern amenities like air conditioning, electric heating, and convenient garbage disposal. Picture yourself living here, where comfort meets style in a vibrant community that feels just right for you!",
  "property_home_neighborhood_blurb": "<p>Live steps from Wasson Park, grab a coffee at Dutch Bros, or stock up at Walmart - all close by. You're ten minutes from downtown Colorado Springs, surrounded by local parks and neighborhood gems. Whether it's a picnic, errands, or brunch, life around Bristol Square puts everything within reach.</p>",
  "property_home_reviews_blurb": "At Bristol Square in beautiful Colorado Springs, residents rave about the “welcoming atmosphere” and “friendly staff” that make this community feel like home. Join our vibrant lifestyle and see what our residents have to say about living at our community—your next chapter awaits!",
  "property_neighborhood_blurb": "<p>At Bristol Square, soak up local flavor on Yuma St in Colorado Springs, CO. Just a stroll from Wasson Park and Dutch Bros Coffee, you're close to Walmart for errands and a short drive to downtown. With parks and everyday essentials nearby, your days are full of possibilities, whether grabbing coffee, running errands, or enjoying a green escape right around the corner.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Bristol Square in Colorado Springs, CO, community and in-home amenities bring convenience right to your doorstep. Enjoy relaxing by the outdoor pool, doing laundry on-site, and breeze through everyday tasks with comfort-enhancing touches like air conditioning and ample storage. Your Colorado Springs apartment experience is about comfort and connecting with neighbors.</p>",
  "property_applynow_blurb": "Welcome to Bristol Square in beautiful Colorado Springs, CO, where modern living meets comfort. Choose from stylish studio, one-bedroom, and two-bedroom floor plans, all featuring essential amenities like air conditioning and spacious linen closets. Ready to embrace your ideal lifestyle? Lease your new home online today!",
  "property_contactus_blurb": "<p>Contact our leasing team at Bristol Square in Colorado Springs, CO. We're here to share details about available homes, the area, or to set up a visit. Let's help you find the right fit at Bristol Square.</p>",
  "property_faqs_blurb": "At Bristol Square in Colorado Springs, CO, our diverse apartment layouts—studio, one-bedroom, and two-bedroom—welcome you home. Whether you're seeking cozy efficiency or spacious living, we have the perfect fit. Curious about our community? Visit our FAQs page for insights, tips, and answers to all your burning questions!",
  "property_floorplans_blurb": "<p>Choose from open studio, one-, or two-bedroom apartments for rent in Colorado Springs, CO at Bristol Square. Each home offers space to personalize, whether you're carving out a cozy reading nook or setting up your remote workspace. Enjoy features like air conditioning and a generous linen closet, with storage where you need it and comfort in every season.</p>",
  "property_gallery_blurb": "<p>Flip through the Bristol Square photo gallery and picture life in Colorado Springs, CO. Tour inviting living rooms, kitchen spaces ready for dinner nights, and social areas where neighbors gather. See yourself unwinding at the outdoor pool or relaxing at home - every image captures the welcoming feel and in-home comfort that make Bristol Square unique.</p>",
  "property_interactivemap_blurb": "At Bristol Square in Colorado Springs, CO, find the perfect fit with stylish studio, one, or two-bedroom apartments. Enjoy modern amenities like air conditioning* and convenient garbage disposal. Use our interactive community map to explore available units and pricing—your ideal home awaits!",
  "property_pets_blurb": "At Bristol Square in sunny Colorado Springs, your furry friends are part of the family! With ample green spaces and a pet-friendly atmosphere, our community accommodates up to two pets per household—because every day is a new adventure for you and your companions. Restrictions on specific breeds apply.",
  "property_referafriend_blurb": "At Bristol Square in Colorado Springs, cozy living awaits in our inviting studio, one-bedroom, and two-bedroom floor plans. Why not share the experience? Great friends make great neighbors—refer a friend today and let them join our vibrant community. Together, you'll create unforgettable memories in your new home!",
  "property_residentaccess_blurb": "Welcome to Bristol Square in beautiful Colorado Springs, CO! Whether you crave the cozy charm of a studio, the spaciousness of a one-bedroom, or the elegance of a two-bedroom, we’ve got the perfect floor plan for you. Access your resident portal to easily manage rent payments and maintenance requests!",
  "property_reviews_blurb": "At Bristol Square in Colorado Springs, our residents rave about the welcoming atmosphere: \"The community feels like a second home!\" With stunning views and exceptional amenities, it's no wonder our residents are proud to call this place home. See what our residents have to say about living at our community!",
  "property_created_at": "1771536354410",
  "property_scheduletour_blurb": "<p>Schedule your tour at Bristol Square in Colorado Springs, CO. Choose a guided in-person walk-through, a virtual tour from your couch, or a time that works for you. Our leasing team will help you see every detail and answer your questions about what it's like to live here. Touring restrictions may apply.</p>",
  "property_thankyou_blurb": "Thank you for reaching out to Bristol Square in beautiful Colorado Springs, CO! We offer a variety of inviting floor plans, from cozy studios to spacious two-bedroom apartments. A member of our team will connect with you soon to answer any questions and help you find your perfect new home.",
  "property_virtualtours_blurb": "<p>Discover Bristol Square Apartment Homes in Colorado Springs, CO, with a virtual tour that puts you right inside our inviting spaces. Walk through layouts, check out bright windows and spacious rooms, and imagine life in this friendly community - all from wherever you are. When you're ready, our team can arrange an in-person visit to help you take the next step.</p>",
  "property_copyright": "2026 All Rights Reserved. Bristol Square",
  "property_seo_title_home": "Welcoming Apartments | Bristol Square | Colorado Springs, CO",
  "property_seo_description_home": "Enjoy relaxed living at Bristol Square near Wasson Park, pet-friendly apartments in Colorado Springs, CO, with all-in pricing.",
  "property_seo_title_floorplans": "Floor Plans | Bristol Square | Colorado Springs, CO",
  "property_seo_description_floorplans": "Explore spacious studio, 1, and 2 bedroom floor plans at Bristol Square in Colorado Springs, CO. Find practical layouts that fit your life.",
  "property_seo_title_amenities": "Amenities | Bristol Square | Colorado Springs, CO",
  "property_seo_description_amenities": "Enjoy an outdoor pool, on-site laundry, and in-home comforts at Bristol Square in Colorado Springs, CO.",
  "property_seo_title_gallery": "Photo Gallery | Bristol Square | Colorado Springs, CO",
  "property_seo_description_gallery": "View photos of indoor and outdoor living at Bristol Square in Colorado Springs, CO - see inviting spaces and lifestyle moments.",
  "property_seo_title_virtualtours": "Virtual Tour | Bristol Square | Colorado Springs, CO",
  "property_seo_description_virtualtours": "Take a virtual tour of Bristol Square apartments in Colorado Springs, CO, and discover comfortable layouts from anywhere.",
  "property_seo_title_interactivemap": "Community Site Map & Layout | Bristol Square",
  "property_seo_description_interactivemap": "Explore the Bristol Square community site map. View building locations, parking areas, and available studio to 2-bedroom units in Colorado Springs.",
  "property_seo_title_neighborhood": "Neighborhood | Bristol Square | Colorado Springs, CO",
  "property_seo_description_neighborhood": "Explore life near Wasson Park and Dutch Bros Coffee at Bristol Square in Colorado Springs, CO - enjoy the best the city has to offer.",
  "property_seo_title_contact": "Contact Bristol Square Apartments | Colorado Springs, CO",
  "property_seo_description_contact": "Contact our leasing team at Bristol Square in Colorado Springs, CO, to learn more about available apartments.",
  "property_seo_title_faqs": "Leasing & Resident FAQs | Bristol Square Colorado Springs",
  "property_seo_description_faqs": "Find answers to leasing questions at Bristol Square Apartments in Colorado Springs. Learn about pet policies, utilities, parking, deposits, and floor plans.",
  "property_seo_title_reviews": "Resident Reviews & Ratings | Bristol Square Apartments",
  "property_seo_description_reviews": "Read verified resident reviews for Bristol Square Apartments in Colorado Springs, CO. See what our community says about management, living spaces, and location.",
  "property_seo_title_applynow": "Apply Online | Bristol Square Colorado Springs, CO",
  "property_seo_description_applynow": "Ready to move? Apply online for your studio, 1, or 2-bedroom home at Bristol Square Apartments in Colorado Springs, CO. Fast, secure leasing starts here.",
  "property_seo_title_residentaccess": "Resident Portal Login | Bristol Square Apartments",
  "property_seo_description_residentaccess": "Log in to the Bristol Square Apartments resident portal. Pay rent online, submit routine maintenance requests, and access community updates anytime.",
  "property_seo_title_referafriend": "Resident Referral Program | Bristol Square Apartments",
  "property_seo_description_referafriend": "Refer a friend to Bristol Square Apartments in Colorado Springs and earn resident referral rewards. Contact our leasing office for current details.",
  "property_seo_title_scheduletour": "Schedule a Tour | Bristol Square | Colorado Springs, CO",
  "property_seo_description_scheduletour": "Schedule a guided or virtual tour of Bristol Square in Colorado Springs, CO - discover your next apartment home your way.",
  "property_seo_title_privacy": "Privacy Policy | Bristol Square Apartments",
  "property_seo_description_privacy": "Review the privacy policy for Bristol Square Apartments in Colorado Springs, CO. Learn how our team collects, protects, and manages your personal data.",
  "property_seo_title_accessibility": "Accessibility Statement | Bristol Square Apartments",
  "property_seo_description_accessibility": "Read the digital accessibility statement for Bristol Square Apartments in Colorado Springs, CO. We are committed to an inclusive online experience.",
  "property_seo_title_sitemap": "HTML Site Index | Bristol Square Apartments",
  "property_seo_description_sitemap": "Browse the Bristol Square Apartments sitemap for direct links to floor plans, amenities, photo galleries, virtual tours, and resident services.",
  "property_seo_title_thankyou": "Submission Received | Bristol Square Apartments",
  "property_seo_description_thankyou": "Thank you for contacting Bristol Square Apartments in Colorado Springs. A member of our leasing team will be in touch with you shortly.",
  "property_seo_title_pets": "Pet-Friendly Apartments & Policy | Bristol Square",
  "property_seo_description_pets": "Bristol Square Apartments welcomes cats and dogs! Review our Colorado Springs pet policy, deposit guidelines, breed restrictions, and pet amenities.",
  "property_updated_at": "1793654764149",
  "amenities": [
    {
      "id": "ec_6b87fa86a6ae35aa11297920",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86218272",
      "title": "On-Site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a552075234ed5168a050c38a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111507",
      "title": "Community Bike Rack",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9aec6d22bd004ee492f2b92c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111510",
      "title": "Pool and Lounge Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://cdn.rentcafe.com/dmslivecafe/2/111265/bristol-square-pool-lounge-chairs.JPG",
      "amenity_image_media": null,
      "amenity_image_alt_text": "Bristol Square Outdoor Pool Lounge Chairs",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75d7f1bdae9abf437e51c128",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111512",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfc7e9b5bbfa05e46e044149",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111513",
      "title": "Electric",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3979490dd9aeff9a9326254f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111515",
      "title": "Air Conditioning*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34cb9cfdbfce8ec5f1e1202e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111517",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2305571f5334785ab788cf51",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "86111516",
      "title": "Baseboard Heat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b57f0a2fdcf7434838d9566",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "124799833",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5bab931a8fd9449dad5dc8b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-7948-70dd-8b6d-02be0e2dccda.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and large windows.",
        "public_id": "019d021c-7948-70dd-8b6d-02be0e2dccda",
        "storage_key": "property/6767906449167178/019d021c-7948-70dd-8b6d-02be0e2dccda.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious living room, featuring a plush sectional sofa and ample natural light from large windows.",
      "link": "false",
      "alt_text": "A bright modern living room here at Bristol Square featuring a spacious light gray sectional sofa with neutral throw pillows, a wooden coffee table on a soft area rug, vertical blinds allowing natural light, light-toned walls, and clean finishes that create an open, inviting atmosphere for everyday living and relaxing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(1).jpg"
    },
    {
      "id": "ec_f28098635851d64c9fd706b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-8611-708d-8e13-7f82cd161ed5.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet, white walls, and a window with blinds.",
        "public_id": "019d021c-8611-708d-8e13-7f82cd161ed5",
        "storage_key": "property/6767906449167178/019d021c-8611-708d-8e13-7f82cd161ed5.webp",
        "width": 552,
        "height": 368
      },
      "title": "Apartment",
      "description": "Spacious living room featuring neutral carpet, large window with blinds for natural light, and wall-mounted air conditioning unit. Perfect for creating your own personalized space.",
      "link": "false",
      "alt_text": "A bright and open living room here at Bristol Square featuring plush carpet flooring, soft neutral walls, a wide window with vertical blinds, and a wall-mounted air conditioning unit beneath the window, offering a clean layout with ample natural light and flexible space for comfortable living and furniture placement.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(5).jpg"
    },
    {
      "id": "ec_cfd2863caa2aeb9a2400f9b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-8686-720d-9658-fcdbbca34b16.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet and air conditioning unit.",
        "public_id": "019d021c-8686-720d-9658-fcdbbca34b16",
        "storage_key": "property/6767906449167178/019d021c-8686-720d-9658-fcdbbca34b16.webp",
        "width": 570,
        "height": 380
      },
      "title": "Apartment",
      "description": "Spacious living area with carpet and central air conditioning.",
      "link": "false",
      "alt_text": "A spacious and sunlit living room here at Bristol Square showcasing soft neutral walls, plush carpet flooring, multiple wide windows with vertical blinds, a wall-mounted air conditioning unit, and an open layout that transitions into an adjacent dining area with durable flooring, creating a bright and versatile living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(6).jpg"
    },
    {
      "id": "ec_daf83426d883380eb87886aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-8584-77fb-a4c3-a3d5b39686bf.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and artwork on the wall.",
        "public_id": "019d021c-8584-77fb-a4c3-a3d5b39686bf",
        "storage_key": "property/6767906449167178/019d021c-8584-77fb-a4c3-a3d5b39686bf.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, convenient nightstands, and tasteful wall art for a serene atmosphere.",
      "link": "false",
      "alt_text": "A calm and inviting bedroom here at Bristol Square featuring a queen-sized bed with crisp white bedding and a taupe throw blanket, matching wood nightstands with modern lamps, soft neutral wall art above the headboard, plush carpet flooring, and a wide window with vertical blinds that brings in gentle natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(4).jpg"
    },
    {
      "id": "ec_4c8f07cd4dd86e930b5c0aac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-8691-749b-85b3-c9d3ed4f8078.webp",
      "image_media": {
        "alt_text": "Empty room with carpet, a window with blinds, and a ceiling light.",
        "public_id": "019d021c-8691-749b-85b3-c9d3ed4f8078",
        "storage_key": "property/6767906449167178/019d021c-8691-749b-85b3-c9d3ed4f8078.webp",
        "width": 570,
        "height": 380
      },
      "title": "Apartment",
      "description": "An empty room featuring neutral carpet, a large window with blinds, and a ceiling light fixture. This versatile space can be customized to your needs.",
      "link": "false",
      "alt_text": "A bright and cozy bedroom here at Bristol Square featuring soft neutral walls, plush carpet flooring, a wide window with vertical blinds that allows natural light to fill the room, a simple ceiling light fixture, and a clean rectangular layout that offers flexibility for bedroom furniture and comfortable everyday living.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(7).jpg"
    },
    {
      "id": "ec_7136fa3dffed8d6017b04a16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-912e-74bd-afcb-7d166ed0ee80.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and a window.",
        "public_id": "019d021c-912e-74bd-afcb-7d166ed0ee80",
        "storage_key": "property/6767906449167178/019d021c-912e-74bd-afcb-7d166ed0ee80.webp",
        "width": 570,
        "height": 380
      },
      "title": "Apartment",
      "description": "A spacious and unfurnished bedroom, featuring plush carpeting and ample natural light from a large window. Perfect for personalization.",
      "link": "false",
      "alt_text": "A bright and airy bedroom here at Bristol Square featuring soft white walls, plush carpet flooring, a wide window with vertical blinds for natural light, baseboard heating along the wall, and a simple ceiling light fixture, creating a clean and comfortable space suitable for a variety of bedroom furniture layouts.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(8).jpg"
    },
    {
      "id": "ec_ed8089f94c8989a4497d345e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-dcfe-743e-96ec-1fbee3d6b22a.webp",
      "image_media": {
        "alt_text": "Empty room with tan carpet and a large window with vertical blinds.",
        "public_id": "01a16cb0-dcfe-743e-96ec-1fbee3d6b22a",
        "storage_key": "property/6767906449167178/01a16cb0-dcfe-743e-96ec-1fbee3d6b22a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious empty room with tan carpeting and a large window, perfect for making it your own.",
      "link": "false",
      "alt_text": "A bright, unfurnished bedroom here at Bristol Square featuring neutral carpet flooring, soft white walls, and a wide window with blinds that brings in natural light, creating a clean, open space ready for personal touches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(20).jpg"
    },
    {
      "id": "ec_e4c0edf36d0ef56bf5ff34b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-dbfb-7258-99a7-11c302f5cf07.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and entryways",
        "public_id": "01a16cb0-dbfb-7258-99a7-11c302f5cf07",
        "storage_key": "property/6767906449167178/01a16cb0-dbfb-7258-99a7-11c302f5cf07.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Cozy bedroom with neutral carpeting and ample closet space, featuring two doorways for easy access to other parts of the apartment.",
      "link": "false",
      "alt_text": "A room with carpeted floor and two white doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(18).jpg"
    },
    {
      "id": "ec_69a772ebd71da358fae4ddf3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-79f7-736e-8129-ec51d1740d79.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, stove, and sink.",
        "public_id": "019d021c-79f7-736e-8129-ec51d1740d79",
        "storage_key": "property/6767906449167178/019d021c-79f7-736e-8129-ec51d1740d79.webp",
        "width": 528,
        "height": 352
      },
      "title": "Apartment",
      "description": "Compact kitchen featuring white appliances including a refrigerator and stove, ample cabinet space, and a stainless steel sink. The kitchen opens into a hallway.",
      "link": "false",
      "alt_text": "A clean and functional kitchen here at Bristol Square showcasing light wood cabinetry, white appliances including a full-size refrigerator and range, laminate countertops with a stainless steel sink, decorative place settings, and a tiled floor that connects to a carpeted hallway, creating a bright and practical cooking space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(2).jpg"
    },
    {
      "id": "ec_03800154419e19019baa5d9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-7949-701f-ae03-80f370fdb4d0.webp",
      "image_media": {
        "alt_text": "Kitchen area with white refrigerator, stove, and sink.",
        "public_id": "019d021c-7949-701f-ae03-80f370fdb4d0",
        "storage_key": "property/6767906449167178/019d021c-7949-701f-ae03-80f370fdb4d0.webp",
        "width": 674,
        "height": 488
      },
      "title": "Apartment",
      "description": "This kitchen features a white refrigerator, stove, and a double sink, perfect for preparing meals.",
      "link": "false",
      "alt_text": "A bright and efficient kitchen here at Bristol Square featuring light wood cabinetry, white appliances including a refrigerator and electric range, smooth laminate countertops with a stainless steel sink, simple place settings with green glassware, and a compact layout that opens toward a softly lit hallway, creating a clean and functional cooking space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(3).jpg"
    },
    {
      "id": "ec_d5a10f973ad5ae1cd43c893e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-9fd1-72fb-829b-47159ff8063d.webp",
      "image_media": {
        "alt_text": "On-site laundry room with two top-loading washing machines and a stacked washer-dryer unit.",
        "public_id": "019d021c-9fd1-72fb-829b-47159ff8063d",
        "storage_key": "property/6767906449167178/019d021c-9fd1-72fb-829b-47159ff8063d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers to handle your laundry needs.",
      "link": "false",
      "alt_text": "A clean shared laundry room here at Bristol Square featuring white top-load washing machines and stacked dryers, light tile flooring, neutral walls, posted laundry instructions above the machines, and a large window providing natural light and views of the apartment community outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(12).jpg"
    },
    {
      "id": "ec_3344f8ec3a47dfeee7965b21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-dd76-7526-a2b1-0ee546372340.webp",
      "image_media": {
        "alt_text": "On-site laundry facility with washers, dryers, and a folding table.",
        "public_id": "01a16cb0-dd76-7526-a2b1-0ee546372340",
        "storage_key": "property/6767906449167178/01a16cb0-dd76-7526-a2b1-0ee546372340.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers, along with a folding table for your convenience.",
      "link": "false",
      "alt_text": "A bright shared laundry room here at Bristol Square featuring white top-load washing machines, stacked dryers, a folding table, light tile flooring, neutral walls, posted laundry instructions, and a large window that brings in natural light and overlooks the community grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(21).jpg"
    },
    {
      "id": "ec_5fbdc185c892108e8c4c8641",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-dd69-7677-acf7-3063dae90b14.webp",
      "image_media": {
        "alt_text": "On-site laundry room with multiple washers and dryers.",
        "public_id": "01a16cb0-dd69-7677-acf7-3063dae90b14",
        "storage_key": "property/6767906449167178/01a16cb0-dd69-7677-acf7-3063dae90b14.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents, equipped with modern washers and dryers.",
      "link": "false",
      "alt_text": "A clean, well-lit shared laundry room here at Bristol Square featuring white top-load washing machines, stacked dryers, a utility sink, a folding table, neutral walls, light tile flooring, posted laundry instructions, and overhead lighting with a window providing natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(19).jpg"
    },
    {
      "id": "ec_633075a41970abc3e673e934",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-9451-755e-801a-847e86a5990f.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a brick building in the background.",
        "public_id": "019d021c-9451-755e-801a-847e86a5990f",
        "storage_key": "property/6767906449167178/019d021c-9451-755e-801a-847e86a5990f.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush greenery and comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "A sunny outdoor swimming pool here at Bristol Square featuring a rectangular pool surrounded by a concrete deck, red lounge chairs, green lawn landscaping, and a tall evergreen tree set against brick apartment buildings and a bright blue sky with scattered clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(9).jpg"
    },
    {
      "id": "ec_288b8be59ce5c5cbfbae17b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-9248-704d-bca7-1bb494b03c01.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a large blue spruce tree.",
        "public_id": "019d021c-9248-704d-bca7-1bb494b03c01",
        "storage_key": "property/6767906449167178/019d021c-9248-704d-bca7-1bb494b03c01.webp",
        "width": 2736,
        "height": 1824
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "A refreshing outdoor swimming pool here at Bristol Square showcasing clear blue water, a curved concrete pool deck, red and white lounge chairs, green grass edging, mature trees, and brick apartment buildings under a bright sky with scattered clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(10).jpg"
    },
    {
      "id": "ec_1e64886bf6baa72ab4e17784",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-93b3-7228-b136-d31fc5a40805.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a brick apartment building in the background.",
        "public_id": "019d021c-93b3-7228-b136-d31fc5a40805",
        "storage_key": "property/6767906449167178/019d021c-93b3-7228-b136-d31fc5a40805.webp",
        "width": 2736,
        "height": 1824
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by lush green grass and comfortable lounge chairs. Perfect for relaxing on a sunny day.",
      "link": "false",
      "alt_text": "A sunny outdoor swimming pool here at Bristol Square featuring clear blue water, a rectangular pool with metal handrails, red and white lounge chairs on a concrete deck, trimmed green grass, and a brick apartment building backdrop beneath a bright sky with soft white clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(11).jpg"
    },
    {
      "id": "ec_5910eb4b8ea618993af27e61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-e2eb-76b5-91a7-e68d11139c3b.webp",
      "image_media": {
        "alt_text": "Bristol Square apartment building entrance with monument sign and landscaping",
        "public_id": "01a16cb0-e2eb-76b5-91a7-e68d11139c3b",
        "storage_key": "property/6767906449167178/01a16cb0-e2eb-76b5-91a7-e68d11139c3b.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Welcome to Bristol Square, featuring a prominent monument sign and beautifully landscaped grounds. Enjoy our convenient community amenities and comfortable living spaces.",
      "link": "false",
      "alt_text": "A welcoming apartment community entrance sign here at Bristol Square showcasing a landscaped monument sign surrounded by colorful flowers, decorative stone edging, green lawn, mature trees, parked vehicles, and classic brick apartment buildings beneath a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(24).jpg"
    },
    {
      "id": "ec_0d2b57906a5dd127e2f9728f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-f281-707b-8259-bc5548c10a14.webp",
      "image_media": {
        "alt_text": "Bristol Square property signage with landscaping",
        "public_id": "01a16cb0-f281-707b-8259-bc5548c10a14",
        "storage_key": "property/6767906449167178/01a16cb0-f281-707b-8259-bc5548c10a14.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Welcome sign for Bristol Square apartments, featuring elegant gold lettering on a black background, surrounded by vibrant flowers and lush greenery.",
      "link": "false",
      "alt_text": "A landscaped community entrance sign here at Bristol Square featuring an elegant monument sign surrounded by colorful flowers, decorative stone edging, and lush greenery, with classic brick apartment buildings in the background under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(23).jpg"
    },
    {
      "id": "ec_cfd8b929a3a0e5ca34e376ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a16cb0-f53d-7362-9070-d3fe8400d29e.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with manicured lawns and a sidewalk.",
        "public_id": "01a16cb0-f53d-7362-9070-d3fe8400d29e",
        "storage_key": "property/6767906449167178/01a16cb0-f53d-7362-9070-d3fe8400d29e.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "View of the exterior of the apartment buildings, showcasing the brick facade, windows, and manicured green spaces.",
      "link": "false",
      "alt_text": "A classic brick apartment building exterior here at Bristol Square featuring a main entrance with white columns, an arched window above the doorway, multiple large windows with shutters, well-kept green lawns, a concrete walkway with railings, and additional residential buildings visible in the background under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(22).jpg"
    },
    {
      "id": "ec_3ab4a0b5f88f2617b52c72c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021c-ace8-758b-b1a3-f09a4f8aee89.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d021c-ace8-758b-b1a3-f09a4f8aee89",
        "storage_key": "property/6767906449167178/019d021c-ace8-758b-b1a3-f09a4f8aee89.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Exterior view of the brick apartment building with multiple windows and a central entrance.",
      "link": "false",
      "alt_text": "A charming brick apartment community exterior here at Bristol Square featuring multiple three-story residential buildings with white shutters, arched entryway details, mature trees, manicured landscaping, and a quiet street view under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Bristol-Square_Favorites%20(16).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_bb2e7c12-f0a6-4968-a1e8-243e6480dbc0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "La tiendita market 719",
      "poi_type": "Shopping & Retail",
      "poi_address": "1534 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-6eaf-7186-993b-d0768edbd086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-6eaf-7186-993b-d0768edbd086",
        "storage_key": "property/6767906449167178/01a14131-6eaf-7186-993b-d0768edbd086.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/view/latienditamarket719/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043993039487054079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-tiendita-market-719",
      "poi_latitude": "38.8554807",
      "poi_longitude": "-104.7763879",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 719-358-6659",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b268-747b-ad99-1df3e82fa673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b268-747b-ad99-1df3e82fa673",
        "storage_key": "property/6767906449167178/019d021d-b268-747b-ad99-1df3e82fa673.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxjEWstFE4cR_zATgvb_xtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f2db7ea4-bd07-4628-af09-f7f61c03fd71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1121 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-6ef8-75c6-ab56-b5b8a85c5761.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-6ef8-75c6-ab56-b5b8a85c5761",
        "storage_key": "property/6767906449167178/01a14131-6ef8-75c6-ab56-b5b8a85c5761.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://local.safeway.com/safeway/co/colorado-springs/1121-n-circle-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7451038879510196328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.8484082",
      "poi_longitude": "-104.7723654",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-573-6023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b268-747b-ad99-1df3e82fa673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b268-747b-ad99-1df3e82fa673",
        "storage_key": "property/6767906449167178/019d021d-b268-747b-ad99-1df3e82fa673.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcCj4MBFE4cRaHDUNGJoZ2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4028711d-207e-48e2-8ec2-0b6a0ba10697",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Cheers Liquor Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1105 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Local liquor store featuring a massive selection of beer, wine, and spirits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-6487-735a-8900-163334b24012.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-6487-735a-8900-163334b24012",
        "storage_key": "property/6767906449167178/01a14131-6487-735a-8900-163334b24012.webp",
        "width": 1280,
        "height": 793
      },
      "poi_business_url": "http://www.cheersliquormart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17511096402830193678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheers-liquor-mart",
      "poi_latitude": "38.848543",
      "poi_longitude": "-104.7750114",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-574-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz7-lhMBFE4cRDnRQjmbpA_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_61d9468d-6654-4bcb-b243-4b558c6b48fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "455 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-65fd-76b4-a17e-608e8e82e2d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-65fd-76b4-a17e-608e8e82e2d1",
        "storage_key": "property/6767906449167178/01a14131-65fd-76b4-a17e-608e8e82e2d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/colorado-springs-co-pharmacies/455-north-circle-dr-colorado-springs-co-80909/storeid=11002?WT.mc_id=LS_GOOGLE_FS_11002",
      "poi_directions_map_url": "https://maps.google.com/?cid=9124733950549795883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.8392159",
      "poi_longitude": "-104.775075",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-216-0408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-af46-7019-8c13-5049a4f6b0b6",
        "storage_key": "property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxf6pDv1FE4cRK6R34C6RoX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_92aa3c07-62fd-4c5e-bfe2-811793585d02",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1725 N Union Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Convenient neighborhood grocery store offering well-stocked essentials and quick service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-6f5b-77c9-9cdc-2f1f35079c96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-6f5b-77c9-9cdc-2f1f35079c96",
        "storage_key": "property/6767906449167178/01a14131-6f5b-77c9-9cdc-2f1f35079c96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3176-colorado-springs-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13545070344744263882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "38.8576448",
      "poi_longitude": "-104.7927647",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-424-3385",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b268-747b-ad99-1df3e82fa673.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b268-747b-ad99-1df3e82fa673",
        "storage_key": "property/6767906449167178/019d021d-b268-747b-ad99-1df3e82fa673.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSFXipxFE4cRyuAotLbB-bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e36ee585-33f2-478d-a64c-87f4a3c13601",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3201 E Platte Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Comprehensive department store offering a wide selection of household goods, electronics, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-4edf-76de-976d-0d9221684b6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-4edf-76de-976d-0d9221684b6f",
        "storage_key": "property/6767906449167178/019d021d-4edf-76de-976d-0d9221684b6f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1200-colorado-springs-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12309067056574801145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8374952",
      "poi_longitude": "-104.7705078",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-578-9164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOTPuqM5FE4cR-aSaj0WX0qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f3c2c173-09a5-4a61-89b8-6e236c38a444",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1776 W Uintah St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-647c-7418-a4ba-bd24ba0497e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-647c-7418-a4ba-bd24ba0497e1",
        "storage_key": "property/6767906449167178/01a14131-647c-7418-a4ba-bd24ba0497e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dollartree.com/co/colorado-springs/1776-west-uintah-st?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16824635987268900278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "38.8498591",
      "poi_longitude": "-104.8476376",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-886-1091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJybCue7NaE4cRtpVqKEodfek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_38556bad-d78a-43af-8948-bd4e6f0d0e92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Quart House Liquor",
      "poi_type": "Shopping & Retail",
      "poi_address": "2738 Palmer Park Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-647b-755f-b5f7-67117b439505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-647b-755f-b5f7-67117b439505",
        "storage_key": "property/6767906449167178/01a14131-647b-755f-b5f7-67117b439505.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13330195884583265883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quart-house-liquor",
      "poi_latitude": "38.8545713",
      "poi_longitude": "-104.7767344",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 719-632-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH8K23ZRFE4cRW6b11ode_rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_1c24c58b-a44f-40e5-95e2-39b3cbb417f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Floreria camila",
      "poi_type": "Shopping & Retail",
      "poi_address": "825 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-6872-70d4-a550-77b1d980b035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-6872-70d4-a550-77b1d980b035",
        "storage_key": "property/6767906449167178/01a14131-6872-70d4-a550-77b1d980b035.webp",
        "width": 981,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4619454681390261002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "floreria-camila",
      "poi_latitude": "38.8450346",
      "poi_longitude": "-104.7756833",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 720-429-8753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBQaRRgBFE4cRCiNIzI6ZG0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "florist"
    },
    {
      "id": "custom_2bf928e6-1ad9-4628-bd74-ff462115ba30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "795 Citadel Dr E, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-7561-764f-bf5a-725fa3f35352.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-7561-764f-bf5a-725fa3f35352",
        "storage_key": "property/6767906449167178/01a14131-7561-764f-bf5a-725fa3f35352.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2608",
      "poi_directions_map_url": "https://maps.google.com/?cid=2527634067782491915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "38.8433876",
      "poi_longitude": "-104.7582473",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-637-8282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkaLZEdpFE4cRC99Z7Mr1EyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_c4a787f8-4dc9-499f-81e8-1f6e1fdafbe1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Twain Elementary School",
      "poi_type": "Education",
      "poi_address": "3402 E San Miguel St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-7857-7553-b06b-f4d06bb78ae6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-7857-7553-b06b-f4d06bb78ae6",
        "storage_key": "property/6767906449167178/01a14131-7857-7553-b06b-f4d06bb78ae6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://twain.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1560360436846200513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twain-elementary-school",
      "poi_latitude": "38.8508252",
      "poi_longitude": "-104.7666482",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-328-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY5EaX8JFE4cRwYbK14yDpxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e311313e-2cb9-47dd-8eed-150b63c7b541",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Galileo Middle School",
      "poi_type": "Education",
      "poi_address": "1600 N Union Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-76d5-73cd-b3b0-5d090396ce30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-76d5-73cd-b3b0-5d090396ce30",
        "storage_key": "property/6767906449167178/01a14131-76d5-73cd-b3b0-5d090396ce30.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://galileo.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9424738394404956986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "galileo-middle-school",
      "poi_latitude": "38.8562471",
      "poi_longitude": "-104.7953728",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-328-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnavMZ5xFE4cROit-o6Jly4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6924d4ab-7c7c-4245-92ca-0e8c30243f00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Mitchell High School",
      "poi_type": "Education",
      "poi_address": "1205 Potter Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-76d0-72f9-983c-d6f3f15fbb8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-76d0-72f9-983c-d6f3f15fbb8e",
        "storage_key": "property/6767906449167178/01a14131-76d0-72f9-983c-d6f3f15fbb8e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://mitchell.d11.org/?utm_source=cumulus&utm_medium=onlinepresence&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3619518288724772838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mitchell-high-school",
      "poi_latitude": "38.8496259",
      "poi_longitude": "-104.75071280000002",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-328-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH0jFE3ZGE4cR5kd44bQcOzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_81868f7f-d1ea-4740-b6b2-04c8b1861333",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Queen Palmer Elementary School",
      "poi_type": "Education",
      "poi_address": "1921 E Yampa St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-762e-707e-b0be-b4c007a6d043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-762e-707e-b0be-b4c007a6d043",
        "storage_key": "property/6767906449167178/01a14131-762e-707e-b0be-b4c007a6d043.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://queenpalmer.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15062584154817819750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queen-palmer-elementary-school",
      "poi_latitude": "38.846063099999995",
      "poi_longitude": "-104.7923706",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-328-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7rS66NFE4cRZvRX23sMCdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2ef1517f-4a69-4ae7-8cd5-8d601c4b722c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Rogers Elementary School",
      "poi_type": "Education",
      "poi_address": "110 S Circle Dr, Colorado Springs, CO 80910, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rogers.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3157364405825676247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-elementary-school",
      "poi_latitude": "38.829694",
      "poi_longitude": "-104.7768632",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-328-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY9vUwUpEE4cR16Oz2zI20Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d5633823-7177-4079-8747-6b4319062111",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Odyssey Early College and Career Options",
      "poi_type": "Education",
      "poi_address": "2115 Afton Way, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-7941-7635-9d4e-ea86dff078da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-7941-7635-9d4e-ea86dff078da",
        "storage_key": "property/6767906449167178/01a14131-7941-7635-9d4e-ea86dff078da.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://odyssey.d11.org/?utm_source=cumulus&utm_medium=onlinepresence&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16575186329169585147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odyssey-early-college-and-career-options",
      "poi_latitude": "38.861256",
      "poi_longitude": "-104.7822919",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-328-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTZRvQ3pFE4cR-2MQtCXkBuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_98329961-963e-4b78-a4ea-bdaedd74ef1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Colorado Early Colleges Colorado Springs",
      "poi_type": "Education",
      "poi_address": "4405 N Chestnut St d, Colorado Springs, CO 80907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-7ac3-758e-943f-b9a7bccdd7c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-7ac3-758e-943f-b9a7bccdd7c4",
        "storage_key": "property/6767906449167178/01a14131-7ac3-758e-943f-b9a7bccdd7c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradoearlycolleges.org/coloradosprings/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4965258039650525520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-early-colleges-colorado-springs",
      "poi_latitude": "38.893142999999995",
      "poi_longitude": "-104.832955",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-955-4675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWedvs9pPE4cRUKGFR-Ej6EQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4565674b-159a-4370-a2ff-967c05a61d9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Springs of Life Children's Center - Academy & Maizeland",
      "poi_type": "Education",
      "poi_address": "2385 Academy Pl, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Day care center focused on early childhood development and learning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-860e-749d-b2e7-dd12bf0355d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-860e-749d-b2e7-dd12bf0355d3",
        "storage_key": "property/6767906449167178/01a14131-860e-749d-b2e7-dd12bf0355d3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.childcare.springsoflife.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5390547578278989331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springs-of-life-childrens-center---academy--maizeland",
      "poi_latitude": "38.867144499999995",
      "poi_longitude": "-104.7552114",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-550-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs9GGVfxFE4cRE04pTHYSz0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_31c1c54b-7d95-4c42-a3a6-2a2f1a18ca2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Holy Cross Lutheran School",
      "poi_type": "Education",
      "poi_address": "4125 Constitution Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-7d24-7248-8027-85efe55761e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-7d24-7248-8027-85efe55761e3",
        "storage_key": "property/6767906449167178/01a14131-7d24-7248-8027-85efe55761e3.webp",
        "width": 500,
        "height": 281
      },
      "poi_business_url": "https://www.holycrosscs.org/school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9833011320385233996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-cross-lutheran-school",
      "poi_latitude": "38.8610007",
      "poi_longitude": "-104.7488886",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-596-0661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw1M8dwlGE4cRTOT0x7LfdYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_62c6db92-fc86-4234-ba24-71562ae121fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Pikes Peak State College - Downtown Campus",
      "poi_type": "Education",
      "poi_address": "100 W Pikes Peak Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-7ea4-71d8-8aca-8859ef203269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-7ea4-71d8-8aca-8859ef203269",
        "storage_key": "property/6767906449167178/01a14131-7ea4-71d8-8aca-8859ef203269.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pikespeak.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7340678470133529635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-state-college---downtown-campus",
      "poi_latitude": "38.8350405",
      "poi_longitude": "-104.82731280000002",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-502-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ8R0sjxFE4cRI7yqDi1U32U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d2df3516-4c5d-426a-a462-3ca1be7029fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Pikes Peak Center For The Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "190 S Cascade Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Performing arts theater hosting diverse concerts, symphonies, and live performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-6447-7338-a5a2-34b1f966d1c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-6447-7338-a5a2-34b1f966d1c3",
        "storage_key": "property/6767906449167178/019d021d-6447-7338-a5a2-34b1f966d1c3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pikespeakcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500179945342731688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-center-for-the-performing-arts",
      "poi_latitude": "38.8309234",
      "poi_longitude": "-104.8265795",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-477-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0bd-74ce-9c70-b633e903b7a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0bd-74ce-9c70-b633e903b7a3",
        "storage_key": "property/6767906449167178/01a14131-c0bd-74ce-9c70-b633e903b7a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJScDMxCNFE4cRqIU5z7rYmJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2d5cd790-ace5-43ac-94ad-d07e5f32f08d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Colorado Springs Pioneers Museum",
      "poi_type": "Entertainment",
      "poi_address": "215 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Vast regional history & rotating exhibits, from art to Native American culture, with free admission.",
      "poi_long_description": "Vast regional history & rotating exhibits, from art to Native American culture, with free admission.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-6dc3-72ec-832d-39ece6c102a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412f-6dc3-72ec-832d-39ece6c102a1",
        "storage_key": "property/6767906449167178/01a1412f-6dc3-72ec-832d-39ece6c102a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cspm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9327562209550981375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-pioneers-museum",
      "poi_latitude": "38.830359",
      "poi_longitude": "-104.822827",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 719-385-5990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b649-75f7-8389-24cca04258ee",
        "storage_key": "property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6xLHSJFE4cR_9ik-GgocoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0c140b83-2de1-4bf1-a0ec-1957b95c8aa7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Ghost Town Museum",
      "poi_type": "Entertainment",
      "poi_address": "400 21st St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "A model town of historic structures & artifacts, with gold panning & other activities for kids.",
      "poi_long_description": "A model town of historic structures & artifacts, with gold panning & other activities for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-8054-74c7-a002-e57cffa61a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-8054-74c7-a002-e57cffa61a2a",
        "storage_key": "property/6767906449167178/01a14131-8054-74c7-a002-e57cffa61a2a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.ghosttownmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14978692687655113610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ghost-town-museum",
      "poi_latitude": "38.8404749",
      "poi_longitude": "-104.8607719",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-634-0696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b649-75f7-8389-24cca04258ee",
        "storage_key": "property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57p3fMdaE4cRipNsj6MB388",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_34392096-f6cc-45f7-80c4-9add67de13ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "U.S. Olympic & Paralympic Museum",
      "poi_type": "Entertainment",
      "poi_address": "200 S Sierra Madre St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Displays on American athletes & Olympic history, plus immersive sport exhibits & simulators.",
      "poi_long_description": "Displays on American athletes & Olympic history, plus immersive sport exhibits & simulators.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-6e8d-7379-b49d-73237278dbc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412f-6e8d-7379-b49d-73237278dbc5",
        "storage_key": "property/6767906449167178/01a1412f-6e8d-7379-b49d-73237278dbc5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://usopm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=652128693993578406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-olympic--paralympic-museum",
      "poi_latitude": "38.8296712",
      "poi_longitude": "-104.8295217",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-497-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b649-75f7-8389-24cca04258ee",
        "storage_key": "property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJezHngJ5FE4cRpp9TkZfTDAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1bb28a65-5582-40de-9b29-7a17c39a0647",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Garden of the Gods Visitor & Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "1805 N 30th St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Educational visitor center offering park history exhibits, guided outdoor tours, and on-site dining and shopping.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-68c7-73c6-916f-9bf9e0624286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-68c7-73c6-916f-9bf9e0624286",
        "storage_key": "property/6767906449167178/019d021d-68c7-73c6-916f-9bf9e0624286.webp",
        "width": 1280,
        "height": 334
      },
      "poi_business_url": "https://gardenofgods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6587710856062110015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-of-the-gods-visitor--nature-center",
      "poi_latitude": "38.8783986",
      "poi_longitude": "-104.8697704",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-634-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b649-75f7-8389-24cca04258ee",
        "storage_key": "property/6767906449167178/019d021d-b649-75f7-8389-24cca04258ee.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6oa22pQE4cRPwmR0h5AbFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_5ba851df-9c6d-49d6-b7c7-16feafc91232",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Fine Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "30 W Dale St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Historic cultural center with renowned American art collection, large performance theater & classes.",
      "poi_long_description": "Historic cultural center with renowned American art collection, large performance theater & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-6338-7157-a4a8-5c80c2c76f56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-6338-7157-a4a8-5c80c2c76f56",
        "storage_key": "property/6767906449167178/019d021d-6338-7157-a4a8-5c80c2c76f56.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://fac.coloradocollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13047541867328776338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fine-arts-center",
      "poi_latitude": "38.8457835",
      "poi_longitude": "-104.8261714",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-634-5581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0bd-74ce-9c70-b633e903b7a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0bd-74ce-9c70-b633e903b7a3",
        "storage_key": "property/6767906449167178/01a14131-c0bd-74ce-9c70-b633e903b7a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2B2mkBFE4cRkigrEjMuErU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63ce4f64-421c-4fef-833f-d9410ce03358",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4250 Cheyenne Mountain Zoo Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_long_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-89b3-77e8-88d0-b5326bf4b61b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-89b3-77e8-88d0-b5326bf4b61b",
        "storage_key": "property/6767906449167178/01a14131-89b3-77e8-88d0-b5326bf4b61b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10507210585571489614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-zoo",
      "poi_latitude": "38.7703872",
      "poi_longitude": "-104.8548688",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 719-633-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0c0-756c-98ea-5bce7ef6a591.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0c0-756c-98ea-5bce7ef6a591",
        "storage_key": "property/6767906449167178/01a14131-c0c0-756c-98ea-5bce7ef6a591.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk6vByq9cE4cRTnc2pVsc0ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_90edb9c0-bd85-48fc-bdd0-6f49cff2e53a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Cave of the Winds Mountain Park",
      "poi_type": "Entertainment",
      "poi_address": "100 Cave of the Winds Rd, Manitou Springs, CO 80829, USA",
      "poi_short_description": "This historic cave has several tour options, including spelunking, plus a zip line & ropes course.",
      "poi_long_description": "This historic cave has several tour options, including spelunking, plus a zip line & ropes course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-86d2-728d-b2cb-a401d2e85065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-86d2-728d-b2cb-a401d2e85065",
        "storage_key": "property/6767906449167178/01a14131-86d2-728d-b2cb-a401d2e85065.webp",
        "width": 431,
        "height": 450
      },
      "poi_business_url": "https://caveofthewinds.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9929591581785700776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cave-of-the-winds-mountain-park",
      "poi_latitude": "38.8725916",
      "poi_longitude": "-104.9201269",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 719-685-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0be-72ac-93d2-c13ff0409991.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0be-72ac-93d2-c13ff0409991",
        "storage_key": "property/6767906449167178/01a14131-c0be-72ac-93d2-c13ff0409991.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJk9YPNLlQE4cRqLkLNe_-zIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_947bb438-b9e3-4cd3-aa01-9b4fd2a573cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "The Broadmoor Seven Falls",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1045 Lower Gold Camp Rd, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Park focused on scenic waterfalls & geologic monuments that also has a historic gravesite.",
      "poi_long_description": "Park focused on scenic waterfalls & geologic monuments that also has a historic gravesite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-7d77-70d1-b09c-f1b5006300fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412f-7d77-70d1-b09c-f1b5006300fc",
        "storage_key": "property/6767906449167178/01a1412f-7d77-70d1-b09c-f1b5006300fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sevenfalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8987375542602143609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor-seven-falls",
      "poi_latitude": "38.823130899999995",
      "poi_longitude": "-104.8487188",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 855-923-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-90a1-703d-a14c-ecf8cb2a0363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412f-90a1-703d-a14c-ecf8cb2a0363",
        "storage_key": "property/6767906449167178/01a1412f-90a1-703d-a14c-ecf8cb2a0363.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaCcQGRbE4cReZfVV3CSuXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_c235837f-9577-4044-9d3c-6febb8c5a6a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "The Black Sheep",
      "poi_type": "Entertainment",
      "poi_address": "2106 E Platte Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Intimate standing-room-only concert hall with a cutting-edge punk- & indie-rock vibe & graffiti art.",
      "poi_long_description": "Intimate standing-room-only concert hall with a cutting-edge punk- & indie-rock vibe & graffiti art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-88c8-74c9-a1d8-d27621703d7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-88c8-74c9-a1d8-d27621703d7e",
        "storage_key": "property/6767906449167178/01a14131-88c8-74c9-a1d8-d27621703d7e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.blacksheeprocks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10953314261584298664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-black-sheep",
      "poi_latitude": "38.8373461",
      "poi_longitude": "-104.7893111",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-227-7625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0bd-74ce-9c70-b633e903b7a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0bd-74ce-9c70-b633e903b7a3",
        "storage_key": "property/6767906449167178/01a14131-c0bd-74ce-9c70-b633e903b7a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0wRra9FE4cRqMLzqkn9AZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_299a23ed-1262-410f-b842-9fda3b9b6878",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "UCHealth Memorial Hospital Central",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 E Boulder St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-6fd5-761e-8492-9f0c85753d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-6fd5-761e-8492-9f0c85753d17",
        "storage_key": "property/6767906449167178/019d021d-6fd5-761e-8492-9f0c85753d17.webp",
        "width": 1250,
        "height": 781
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-memorial-hospital-central/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13025990946729059480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-memorial-hospital-central",
      "poi_latitude": "38.8402345",
      "poi_longitude": "-104.7991331",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-365-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b64b-7618-8592-2e926b195a97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b64b-7618-8592-2e926b195a97",
        "storage_key": "property/6767906449167178/019d021d-b64b-7618-8592-2e926b195a97.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcNT_3JFE4cRmGQ9W8CdxbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b1b29297-dd83-4ac9-8e8f-faa8c38337bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "CommonSpirit Primary Care Penrose Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3027 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-8fd4-74ef-99af-446fb5d5a51e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-8fd4-74ef-99af-446fb5d5a51e",
        "storage_key": "property/6767906449167178/01a14131-8fd4-74ef-99af-446fb5d5a51e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/commonspirit-primary-care-penrose-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=4614230786338309674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-primary-care-penrose-hospital",
      "poi_latitude": "38.8743797",
      "poi_longitude": "-104.7935959",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-776-4646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-af46-7019-8c13-5049a4f6b0b6",
        "storage_key": "property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxa2un5PE4cRKsZd83MKCUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_344df78d-f112-4de1-9ccd-5c1f57117036",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "920 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-8d9a-719b-a954-4371a4d4482d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-8d9a-719b-a954-4371a4d4482d",
        "storage_key": "property/6767906449167178/01a14131-8d9a-719b-a954-4371a4d4482d.webp",
        "width": 1280,
        "height": 599
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-920+n+circle+dr-colorado+springs-co-80909/id=4043",
      "poi_directions_map_url": "https://maps.google.com/?cid=809773681761833871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.8464971",
      "poi_longitude": "-104.7765604",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-473-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b67f-7445-9dc4-e16ed18adf63",
        "storage_key": "property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZ5bS79FE4cRj9Pfid_kPAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e92351a0-f7fa-4902-bd32-e8cc85451a7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "455 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-8e48-7466-845e-bd2745de0c54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-8e48-7466-845e-bd2745de0c54",
        "storage_key": "property/6767906449167178/01a14131-8e48-7466-845e-bd2745de0c54.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/colorado-springs-co-pharmacies/455-north-circle-dr-colorado-springs-co-80909/storeid=11002?WT.mc_id=LS_GOOGLE_RX_11002",
      "poi_directions_map_url": "https://maps.google.com/?cid=10682794647559923865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.8392458",
      "poi_longitude": "-104.7753027",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-216-0408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b67f-7445-9dc4-e16ed18adf63",
        "storage_key": "property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYfbAihFE4cRmehA0CHpQJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_304c8d20-9466-4644-8089-c4856d4a7862",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1121 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-8d95-73fd-86f7-6989c08a598f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-8d95-73fd-86f7-6989c08a598f",
        "storage_key": "property/6767906449167178/01a14131-8d95-73fd-86f7-6989c08a598f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/co/colorado-springs/1121-n-circle-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2220471678024625084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "38.8484357",
      "poi_longitude": "-104.7723665",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-573-6061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b67f-7445-9dc4-e16ed18adf63",
        "storage_key": "property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcCj4MBFE4cRvCt5Ajqz0B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_bc437db0-24ac-4f50-8ca0-2af6555f46aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "FoundersRX",
      "poi_type": "Health and Wellness",
      "poi_address": "4162 E Bijou St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://foundersrx.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8787282434100663474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foundersrx",
      "poi_latitude": "38.8389552",
      "poi_longitude": "-104.7498221",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-247-1108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b67f-7445-9dc4-e16ed18adf63",
        "storage_key": "property/6767906449167178/019d021d-b67f-7445-9dc4-e16ed18adf63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxEfoDBHE4cRspSZGdGy8nk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_75080006-a880-4a31-8a85-40ced79b7ec1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Downtown YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "207 N Nevada Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Community gym featuring a pool, basketball court, and racquetball facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-7b01-714a-b3ce-d0ca29b86051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412f-7b01-714a-b3ce-d0ca29b86051",
        "storage_key": "property/6767906449167178/01a1412f-7b01-714a-b3ce-d0ca29b86051.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ppymca.org/location/downtown-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14946895381681272175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-ymca",
      "poi_latitude": "38.8370859",
      "poi_longitude": "-104.8212558",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-473-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWgawxdFE4cRb_UJWCgKbs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7a191780-0ae0-4912-b798-8fef3779ffcb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "CorePower Yoga - Nevada",
      "poi_type": "Health and Wellness",
      "poi_address": "623 N Nevada Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Welcoming yoga studio offering a variety of heated and mindful fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-7d9e-74fe-91bd-f8efe2deece4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-7d9e-74fe-91bd-f8efe2deece4",
        "storage_key": "property/6767906449167178/019d021d-7d9e-74fe-91bd-f8efe2deece4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/co/colorado-springs/nevada",
      "poi_directions_map_url": "https://maps.google.com/?cid=7619891903388903058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---nevada",
      "poi_latitude": "38.8432351",
      "poi_longitude": "-104.8208436",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGTYxoBVFE4cRkuZecFBLv2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_7635d0ea-7a33-4824-83f3-1fbf15613405",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "One Body Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "710 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Welcoming Pilates-based workout studio offering classes and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-91ce-720d-898c-4599b7aa80db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-91ce-720d-898c-4599b7aa80db",
        "storage_key": "property/6767906449167178/01a14131-91ce-720d-898c-4599b7aa80db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.onebodyfitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4220481538926425412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-body-fitness-studio",
      "poi_latitude": "38.8240439",
      "poi_longitude": "-104.8244173",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-685-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-af46-7019-8c13-5049a4f6b0b6",
        "storage_key": "property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4al1rpFE4cRRLXNPJkpkjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_a446d893-af77-4713-8bb4-0042bfeabb92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1025 E Woodmen Rd Ste 100, Colorado Springs, CO 80920, USA",
      "poi_short_description": "Welcoming 24/7 gym featuring extensive cardio and strength equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021e-0a5b-75bc-88ab-b2d6fc3fbf13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021e-0a5b-75bc-88ab-b2d6fc3fbf13",
        "storage_key": "property/6767906449167178/019d021e-0a5b-75bc-88ab-b2d6fc3fbf13.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/colorado-springs-e-woodmen-rd-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15669638729024483109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.9313078",
      "poi_longitude": "-104.8064232",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-600-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-af46-7019-8c13-5049a4f6b0b6",
        "storage_key": "property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0c1e1xPE4cRJS81Gme9ddk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a28cd8d2-6458-456f-9d44-baf54b92bc8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Palmer Park Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3650 Maizeland Rd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Mountain-like terrain with trails winding through scrub brush, pines and cacti.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-9732-7438-8518-0794c9fdbe77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-9732-7438-8518-0794c9fdbe77",
        "storage_key": "property/6767906449167178/01a14131-9732-7438-8518-0794c9fdbe77.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11076527494439290367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmer-park-trailhead",
      "poi_latitude": "38.8678562",
      "poi_longitude": "-104.7616803",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0WMOfpFE4cR_8Xm-hG7t5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_57cb71f3-5a11-4aee-a4ce-9b1f598e3a23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Monument Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "170 W Cache La Poudre St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Century-old park with ballfields & paths for running & cycling, plus a pool & formal gardens.",
      "poi_long_description": "Century-old park with ballfields & paths for running & cycling, plus a pool & formal gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-9b22-714e-b483-c5ebde27b58c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-9b22-714e-b483-c5ebde27b58c",
        "storage_key": "property/6767906449167178/01a14131-9b22-714e-b483-c5ebde27b58c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/monument-valley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13621370286329543394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monument-valley-park",
      "poi_latitude": "38.8465688",
      "poi_longitude": "-104.8280831",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yQ_YURFE4cR4rq7NhvUCL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_713135b4-40fa-4a69-850f-08f6cf46f352",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1605 E Pikes Peak Ave, Colorado Springs, CO 80910, USA",
      "poi_short_description": "Lakeside park with swimming & boating plus sports facilities such as a velodrome & tennis courts.",
      "poi_long_description": "Lakeside park with swimming & boating plus sports facilities such as a velodrome & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-8076-77f0-b1b3-edc1ac6ba8f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412f-8076-77f0-b1b3-edc1ac6ba8f7",
        "storage_key": "property/6767906449167178/01a1412f-8076-77f0-b1b3-edc1ac6ba8f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/memorialpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762717626599099076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "38.8316658",
      "poi_longitude": "-104.7994188",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_sToXJEE4cRxEpSMiZJ-U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ad46e8ae-f4bb-4c57-aafe-563a587dedd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Leon Young Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Corona St &, E Fountain Blvd, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-9b87-7027-ad1d-efb8cfcb177d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-9b87-7027-ad1d-efb8cfcb177d",
        "storage_key": "property/6767906449167178/01a14131-9b87-7027-ad1d-efb8cfcb177d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4405798656320951617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leon-young-pavilion",
      "poi_latitude": "38.821535399999995",
      "poi_longitude": "-104.8169433",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXrH2lpFE4cRQVXn9YiKJD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_66078e86-0883-4006-a942-566dafe64c0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Patty Jewett Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 E Espanola St, Colorado Springs, CO 80907, USA",
      "poi_short_description": "Historical golf complex featuring an 18-hole course & a 9-hole course, plus a shop & an eatery.",
      "poi_long_description": "Historical golf complex featuring an 18-hole course & a 9-hole course, plus a shop & an eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-9ada-75d2-bbb7-0806d03116ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-9ada-75d2-bbb7-0806d03116ed",
        "storage_key": "property/6767906449167178/01a14131-9ada-75d2-bbb7-0806d03116ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/pattyjewett",
      "poi_directions_map_url": "https://maps.google.com/?cid=14758230452987073676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patty-jewett-golf-course",
      "poi_latitude": "38.8591667",
      "poi_longitude": "-104.8025",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-385-6934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0c1-778e-b839-cced89e7e528.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0c1-778e-b839-cced89e7e528",
        "storage_key": "property/6767906449167178/01a14131-c0c1-778e-b839-cced89e7e528.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1-h1HlFE4cRjJSlj2fEz8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ac027e3f-6799-4445-bb7b-7b85bffb71a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Alamo Square Park, Colorado Springs",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "215 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-9b90-705b-b3ed-fbda55180e3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-9b90-705b-b3ed-fbda55180e3d",
        "storage_key": "property/6767906449167178/01a14131-9b90-705b-b3ed-fbda55180e3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/alamo-square-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=222108790044900831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-square-park-colorado-springs",
      "poi_latitude": "38.8303133",
      "poi_longitude": "-104.8228256",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTGyAiJFE4cR3z0ejMQWFQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b212e49b-7b84-4790-b6a6-cf7445e7d0c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Acacia Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "115 E Platte Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Small community green space with picnic tables, a playground, horseshoe pits & walking paths.",
      "poi_long_description": "Small community green space with picnic tables, a playground, horseshoe pits & walking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-a67a-747d-8814-b8ede0c69955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-a67a-747d-8814-b8ede0c69955",
        "storage_key": "property/6767906449167178/01a14131-a67a-747d-8814-b8ede0c69955.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks-recreation-and-cultural-services/page/neighborhood-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12240621140338346222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acacia-park",
      "poi_latitude": "38.8373553",
      "poi_longitude": "-104.8224447",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4-pfD1FE4cR7ggB1BJs36k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6b99ecc6-1201-4afe-987b-3efbbb33ac79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "North Cheyenne Cañon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2120 S Cheyenne Canyon Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-a302-74ce-ab88-4d017159ce82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-a302-74ce-ab88-4d017159ce82",
        "storage_key": "property/6767906449167178/01a14131-a302-74ce-ab88-4d017159ce82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/NCC",
      "poi_directions_map_url": "https://maps.google.com/?cid=8704094424560095701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-cheyenne-caon-park",
      "poi_latitude": "38.7909863",
      "poi_longitude": "-104.8653007",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-385-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b625-727f-8675-88f04fe3dba1",
        "storage_key": "property/6767906449167178/019d021d-b625-727f-8675-88f04fe3dba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xsxAHRbE4cR1dFcS8Mny3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6e6c4fc6-09b2-4d78-aa84-fe42a0992491",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Metro Downtown Bus Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "127 E Kiowa St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-a242-7621-b369-4e6a04783724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-a242-7621-b369-4e6a04783724",
        "storage_key": "property/6767906449167178/01a14131-a242-7621-b369-4e6a04783724.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16550523255779328766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-downtown-bus-terminal",
      "poi_latitude": "38.834925",
      "poi_longitude": "-104.8220235",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-af46-7019-8c13-5049a4f6b0b6",
        "storage_key": "property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDABxhFE4cR_oKRczZFr-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e5ae0030-60c6-43e0-8e81-609ef08de0f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Colorado Springs Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916, USA",
      "poi_short_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_long_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-983e-77b3-9e15-bb08d8962eb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-983e-77b3-9e15-bb08d8962eb0",
        "storage_key": "property/6767906449167178/019d021d-983e-77b3-9e15-bb08d8962eb0.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.flycos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5054110453719476621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-airport",
      "poi_latitude": "38.8036959",
      "poi_longitude": "-104.7112051",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 719-550-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b9a5-77ad-8fdc-1c43b103b58b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b9a5-77ad-8fdc-1c43b103b58b",
        "storage_key": "property/6767906449167178/019d021d-b9a5-77ad-8fdc-1c43b103b58b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQvRTypHE4cRjamJCa7OI0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b939e4ef-68f3-4eaa-9541-43338549ab04",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Tejon Park-n-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "S Tejon St & Ronald Reagan H, Colorado Springs, CO 80905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-a291-7552-a89d-aa15e76781a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-a291-7552-a89d-aa15e76781a1",
        "storage_key": "property/6767906449167178/01a14131-a291-7552-a89d-aa15e76781a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3764909945155561880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tejon-park-n-ride",
      "poi_latitude": "38.815306",
      "poi_longitude": "-104.8232167",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c100-7131-a8a1-9d7edcdeaf67",
        "storage_key": "property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7ZxttxEE4cRmClV1KWlPzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_0956f3db-34ca-4e3a-8883-c4b7be663019",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Woodmen Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "6910 Mark Dabling Blvd, Colorado Springs, CO 80919, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-a86c-7345-98ea-56daaf2e90d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-a86c-7345-98ea-56daaf2e90d1",
        "storage_key": "property/6767906449167178/01a14131-a86c-7345-98ea-56daaf2e90d1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3052945528737043137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodmen-park-and-ride",
      "poi_latitude": "38.9321944",
      "poi_longitude": "-104.8155446",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-385-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c100-7131-a8a1-9d7edcdeaf67",
        "storage_key": "property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8OsQmlOE4cRwRL9fsg9Xio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_255ae3df-1554-4829-9c40-cc2ef9008b3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Woodmoor Dr, Monument, CO 80132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.coloradodot.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11288222978045675874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride",
      "poi_latitude": "39.0945495",
      "poi_longitude": "-104.8621844",
      "poi_miles_from_property": "21.6",
      "poi_walking_minutes": "8 hours 11 mins",
      "poi_biking_minutes": "2 hours 23 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c100-7131-a8a1-9d7edcdeaf67",
        "storage_key": "property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeCF5e6tbIcRYonQr_3Sp5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_947e539e-abd4-4814-8611-322d1aeb4436",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "The Citadel Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Citadel Dr E, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Mall with apparel, cosmetics, jewelry & electronics stores, salons, a food court & play areas.",
      "poi_long_description": "Mall with apparel, cosmetics, jewelry & electronics stores, salons, a food court & play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-a934-757d-8e99-5407f6ad7a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-a934-757d-8e99-5407f6ad7a8c",
        "storage_key": "property/6767906449167178/01a14131-a934-757d-8e99-5407f6ad7a8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shopthecitadel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11809864765923250893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-citadel-mall",
      "poi_latitude": "38.8435391",
      "poi_longitude": "-104.7604257",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-591-5515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2c7-771e-904d-d874fcdcb05f",
        "storage_key": "property/6767906449167178/019d021d-b2c7-771e-904d-d874fcdcb05f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV8YVEdpFE4cRzdJB6m4R5aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1da49724-380d-4b39-918b-45ff5480d5bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Voyager Transfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Colorado Springs, CO 80920, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6965618429103935134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "voyager-transfer-station",
      "poi_latitude": "38.95033",
      "poi_longitude": "-104.80148",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c101-774d-a756-78e595028e2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c101-774d-a756-78e595028e2a",
        "storage_key": "property/6767906449167178/01a14131-c101-774d-a756-78e595028e2a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7AmgX9OE4cRno6nSw7ZqmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_c1ea39c3-5c99-4f81-8922-4d8bdcb2f83b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Black Forest Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7503 Black Forest Rd, Colorado Springs, CO 80908, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-aa01-759b-8316-0f60d67c12b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-aa01-759b-8316-0f60d67c12b7",
        "storage_key": "property/6767906449167178/01a14131-aa01-759b-8316-0f60d67c12b7.webp",
        "width": 1262,
        "height": 1280
      },
      "poi_business_url": "https://coloradosprings.gov/mountain-metro/page/park-n-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=1884882744921326491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-forest-park-and-ride",
      "poi_latitude": "38.941474",
      "poi_longitude": "-104.7023467",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c100-7131-a8a1-9d7edcdeaf67",
        "storage_key": "property/6767906449167178/01a14131-c100-7131-a8a1-9d7edcdeaf67.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVydvbAlJE4cRm4NMtt5yKBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_6fb225ff-065b-49a8-9e14-dd7e4e07b934",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "CommonSpirit Penrose Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2222 N Nevada Ave, Colorado Springs, CO 80907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-6f3c-741e-8685-f31c1542ab44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-6f3c-741e-8685-f31c1542ab44",
        "storage_key": "property/6767906449167178/019d021d-6f3c-741e-8685-f31c1542ab44.webp",
        "width": 800,
        "height": 551
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/penrose-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=16350633166847560439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-penrose-hospital",
      "poi_latitude": "38.8661872",
      "poi_longitude": "-104.8224825",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-776-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b64b-7618-8592-2e926b195a97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b64b-7618-8592-2e926b195a97",
        "storage_key": "property/6767906449167178/019d021d-b64b-7618-8592-2e926b195a97.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAd9SD2BFE4cR90qrYjwe6eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_152ea6f0-3b50-4de8-9866-da7e569e5600",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "University of Colorado Colorado Springs",
      "poi_type": "Education",
      "poi_address": "1420 Austin Bluffs Pkwy, Colorado Springs, CO 80918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a1412f-6b60-752f-bbd0-fc3eabefefc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412f-6b60-752f-bbd0-fc3eabefefc1",
        "storage_key": "property/6767906449167178/01a1412f-6b60-752f-bbd0-fc3eabefefc1.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.uccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577512112395933892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-colorado-colorado-springs",
      "poi_latitude": "38.8928151",
      "poi_longitude": "-104.8007996",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-255-8227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTn-iKBPE4cRxFjAYjnfypI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9cdd36fd-2565-402d-9ac5-11ea3ac1126a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Colorado Springs City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "107 N Nevada Ave #300, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-ad7a-741e-a8f0-992ede4278f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-ad7a-741e-a8f0-992ede4278f4",
        "storage_key": "property/6767906449167178/01a14131-ad7a-741e-a8f0-992ede4278f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/city-council",
      "poi_directions_map_url": "https://maps.google.com/?cid=2212328407726945780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-city-hall",
      "poi_latitude": "38.8356581",
      "poi_longitude": "-104.8211502",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-385-5986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b99f-7063-ae3d-04f82075c9a4",
        "storage_key": "property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ968MHhhFE4cR9PURJffEsx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_08e83c15-48ee-40cf-99ac-d7b4050fc558",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Centennial Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 S Cascade Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-b10c-760a-b928-297fe4d37f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-b10c-760a-b928-297fe4d37f60",
        "storage_key": "property/6767906449167178/01a14131-b10c-760a-b928-297fe4d37f60.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1532462004814838776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hall",
      "poi_latitude": "38.830280599999995",
      "poi_longitude": "-104.8263426",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-520-7276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b99f-7063-ae3d-04f82075c9a4",
        "storage_key": "property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-sJMEVFE4cR-HvF9BJmRBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_48ed4cc1-42b2-4a20-b6a3-b6f42c12d8d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "4th Infantry Division Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6105 Wetzel Ave, Fort Carson, CO 80913, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-af23-709a-bb27-859518542f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-af23-709a-bb27-859518542f6e",
        "storage_key": "property/6767906449167178/01a14131-af23-709a-bb27-859518542f6e.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://home.army.mil/carson/units-tenants/4th-infantry-division",
      "poi_directions_map_url": "https://maps.google.com/?cid=7359856924868613663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "4th-infantry-division-headquarters",
      "poi_latitude": "38.7421688",
      "poi_longitude": "-104.7919355",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 719-503-0650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b99f-7063-ae3d-04f82075c9a4",
        "storage_key": "property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxfjuX9DE4cRHxZ-BOF2I2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6a2bdf4e-14df-466f-af8b-1963bce6c80f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Peterson SFB Visitor Center west gate",
      "poi_type": "Entertainment",
      "poi_address": "1334 W Stewart Ave, Colorado Springs, CO 80914, USA",
      "poi_short_description": "Military visitor center providing base access and informative resources.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-b052-70e3-83af-21b3aa3bc7e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-b052-70e3-83af-21b3aa3bc7e2",
        "storage_key": "property/6767906449167178/01a14131-b052-70e3-83af-21b3aa3bc7e2.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "http://www.peterson.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5291928981150453039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peterson-sfb-visitor-center-west-gate",
      "poi_latitude": "38.8318673",
      "poi_longitude": "-104.7087435",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-556-6660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-af46-7019-8c13-5049a4f6b0b6",
        "storage_key": "property/6767906449167178/019d021d-af46-7019-8c13-5049a4f6b0b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIx9R-fxGE4cRL00R2l61cEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_29b2f682-d596-49f0-8a76-853f2dc787bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "Schriever Space Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4186-3708 Enoch Rd, Colorado Springs, CO 80930, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15958673756390935634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schriever-space-force-base",
      "poi_latitude": "38.7977073",
      "poi_longitude": "-104.5131034",
      "poi_miles_from_property": "29.2",
      "poi_walking_minutes": "10 hours 43 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b99f-7063-ae3d-04f82075c9a4",
        "storage_key": "property/6767906449167178/019d021d-b99f-7063-ae3d-04f82075c9a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43z-Pv09E4cRUswHkDqZeN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_6280d42e-721b-4dec-ab9d-36a1c3d9962d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "The Broadmoor",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lake Ave, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Elegant resort accommodations & dining options, plus a spa, a golf course & outdoor activities.",
      "poi_long_description": "Elegant resort accommodations & dining options, plus a spa, a golf course & outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-afef-749e-8b09-b0b3da3a4851.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-afef-749e-8b09-b0b3da3a4851",
        "storage_key": "property/6767906449167178/01a14131-afef-749e-8b09-b0b3da3a4851.webp",
        "width": 1280,
        "height": 633
      },
      "poi_business_url": "https://www.broadmoor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12783829887957334741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor",
      "poi_latitude": "38.7910791",
      "poi_longitude": "-104.8499124",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 855-634-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-c0d1-72d6-aefb-bf0ee1bc6e6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14131-c0d1-72d6-aefb-bf0ee1bc6e6e",
        "storage_key": "property/6767906449167178/01a14131-c0d1-72d6-aefb-bf0ee1bc6e6e.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ2S2v31FbE4cR1fq3LI1JabE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "custom_62fbe42d-b4fb-489e-afea-cd94c03c414c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "custom",
      "poi_name": "United States Air Force Academy",
      "poi_type": "Education",
      "poi_address": "2354 Fairchild Dr Ste 3A15, Air Force Academy, CO 80840, USA",
      "poi_short_description": "Founded in 1954, this famed facility provides training to U.S. Air Force cadets & features exhibits.",
      "poi_long_description": "Founded in 1954, this famed facility provides training to U.S. Air Force cadets & features exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/01a14131-b3c1-7149-b1ac-122325f950bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14131-b3c1-7149-b1ac-122325f950bf",
        "storage_key": "property/6767906449167178/01a14131-b3c1-7149-b1ac-122325f950bf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.usafa.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7058847335799811890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-academy",
      "poi_latitude": "38.992837699999995",
      "poi_longitude": "-104.8582914",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 719-333-2025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-b2a9-75f3-a634-642384d0e30b",
        "storage_key": "property/6767906449167178/019d021d-b2a9-75f3-a634-642384d0e30b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtVAcXNhSE4cRMm8PpkAQ9mE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_35c6f49907b1b2de6180971b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_aed18cd19cdfd5d575203a2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9c5de4aebb35781f326e9460",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f7847a2c65e5d750dbec9f6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c2840fc0f6ef6d24c81c382c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_83de6bb022fe6dc0c2a13010",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "rating": "5",
      "name": "Dylan Rydalch",
      "text": "I recently moved from out of state and the stress that brings can be very overwhelming. What makes it so easy and stress free is when you get to work with property management staff like Jayne and Kylesha. Not only were these two very friendly and understanding, they went above and beyond with their help! They made my move and move in process seamless and effortless. I cannot thank these two enough for their knowledge, professionalism and friendly nature. It really shows how much a leasing staff care about their residents when you get to work with such wonderful staff like Bristol’s team!",
      "date": "2025-12-19",
      "title": "false"
    },
    {
      "id": "ec_8ff46687185a5a9011fcc5cc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "rating": "5",
      "name": "Victoria contreras",
      "text": "Jayne ya ish was very helpful, she was friendly and made this experience so much more easier then anyone before I’m so grateful for her helping me get through a rough time and helping me get into into our place for safety and comfort. She really is amazing give me peace of mind .",
      "date": "2025-05-31",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [
    {
      "id": "ec_39acd329f1554cb0c37b7f13",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "255f48efd30a3a68",
      "name": "MTM Flat Fee",
      "description": "Month to Month Flat Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Lease",
      "charge_code": "mtom",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e4185b8c3e3e874248b56e6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "b6eb9dcca7240e42",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 20,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4aadd5729bbd11e30826fce5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "09a04410077380f2",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Recurring",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_12d37bcfff57ac4703295bc8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "dc31727172292cdf",
      "name": "Electric",
      "description": "Electric Utility",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a3f189df9eb2cc52df35ac5f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "5be6d18f69d1086d",
      "name": "Garbage",
      "description": "Garbage Utility",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "garb",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eb7bd6f8a934a21bdb177623",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "2beeaf9b0f2bda68",
      "name": "Gas",
      "description": "Gas Utility",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8ebcdffa90ee1c51aafc27f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "cea07e4fca0e1bff",
      "name": "Lease Termination Fee",
      "description": "Lease Termination Fee",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_14976b6610d57ed1434628a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "ebdf0ca4bffab8dc",
      "name": "Transfer Fee",
      "description": "Transfer Fee",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_781ab7826516c4459abb2fad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "37c27e0f670bcb1a",
      "name": "Sewer",
      "description": "Sewer Utility",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6eaee5d16e257170e77b60be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "5a57542e4c9d203d",
      "name": "Water",
      "description": "Water Utility",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on usage",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0945814d33ce525ca0e1923b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "29d0baf9b2589256",
      "name": "Pet Screening Fee",
      "description": "Pet Screening Fee - $30 for Card Payments, $25 for ACH Payments. No cost for verified Service Animals.",
      "amount": 25,
      "amount_max": 30,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Move-In",
      "category": "Pet",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_b09e18cd2b827060eb0415ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "2520181",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 0,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_1ec718fd54694567f5c7c5ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "yardi",
      "external_id": "2520180",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 80,
      "deposit": 300,
      "fee": 0,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-daaa-7694-a5c6-bed8c5951175",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bristol Square Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-colorado-springs-bristol",
      "search_query": "air conditioned apartments Colorado Springs",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Colorado Springs",
      "h2_subtitle": "Discover comfort at Bristol Square with air conditioned apartments. Nestled in East Colorado Springs, enjoy modern amenities in a welcoming community.",
      "page_copy": "Bristol Square brings you the perfect blend of comfort and convenience with our air conditioned apartments in Colorado Springs. Located in the vibrant East Colorado Springs neighborhood, our community offers a range of amenities designed to enhance your lifestyle. From spacious linen closets to efficient garbage disposals, each apartment is thoughtfully designed to meet your needs.\n\nStep into a welcoming retreat equipped with baseboard heat and air conditioning, making it an ideal home year-round. With easy access to local attractions and the welcoming atmosphere of East Colorado Springs, Bristol Square stands out as a premier choice for those seeking modern comforts and a prime location. Experience the best of apartment living with air conditioned spaces that promise a comfortable and relaxing environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Colorado Springs",
      "seo_description": "Discover Bristol Square's air conditioned apartments in East Colorado Springs. Enjoy modern amenities designed for comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "apartments-with-garbage-disposal-el-paso-county-bristol",
      "search_query": "apartments with garbage disposal El Paso County",
      "category": "Amenity",
      "h1_title": "Apartments with Garbage Disposal El Paso County",
      "h2_subtitle": "Bristol Square offers well-equipped apartments with garbage disposal. Enjoy modern living in the heart of El Paso County.",
      "page_copy": "Finding the perfect place to call home is easy with Bristol Square's well-appointed apartments, featuring convenient garbage disposals within El Paso County. Our community, located in vibrant East Colorado Springs, blends the convenience of modern amenities with the warmth of a welcoming neighborhood atmosphere.\n\nAt Bristol Square, enjoy the benefits of efficient garbage disposal systems alongside other desirable features like air conditioning and spacious linen closets. Whether you're relaxing in the comfort of baseboard heating or enjoying easy access to local attractions, our apartments are designed for modern living. Discover why Bristol Square is the ideal choice for those looking for functional and stylish homes in a coveted El Paso County location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Garbage Disposal in El Paso County",
      "seo_description": "Explore Bristol Square's El Paso County apartments featuring garbage disposal, modern amenities, and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "linen-closet-apartments-east-colorado-springs-bristol",
      "search_query": "linen closet apartments near East Colorado Springs",
      "category": "Amenity",
      "h1_title": "Linen Closet Apartments Near East Colorado Springs",
      "h2_subtitle": "Explore Bristol Square's apartments with spacious linen closets. Located conveniently in East Colorado Springs, our community offers comfort and style.",
      "page_copy": "Nestled in the heart of East Colorado Springs, Bristol Square offers apartments designed with practicality in mind, including spacious linen closets. Our community is ideally situated in a vibrant part of town, offering easy access to local dining, shopping, and recreation.\n\nEach apartment at Bristol Square is equipped with a range of amenities that cater to your lifestyle needs. From the convenience of garbage disposal systems to the comfort of air conditioning and baseboard heat, every detail has been considered. Our linen closet-equipped apartments are perfect for those who value storage solutions and an organized living space, ensuring you have everything you need right at hand.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Linen Closet Apartments in East Colorado Springs",
      "seo_description": "Discover Bristol Square's East Colorado Springs apartments with linen closets, offering comfort and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "electric-baseboard-heat-apartments-80909-bristol",
      "search_query": "electric and baseboard heat apartments 80909",
      "category": "Amenity",
      "h1_title": "Electric and Baseboard Heat Apartments 80909",
      "h2_subtitle": "Bristol Square offers comfort with electric and baseboard heat. Located in the 80909 area, experience cozy living with modern amenities.",
      "page_copy": "Located in the bustling 80909 zip code, Bristol Square provides residents with comfortable living through our well-appointed apartments featuring electric and baseboard heat. Each unit is designed to offer warmth and efficiency, particularly suited for the varying climate of Colorado Springs.\n\nEnjoy the advantage of these heating options alongside other practical amenities such as garbage disposal systems and spacious linen closets. Nestled in East Colorado Springs, Bristol Square not only promises convenience but also offers a vibrant community atmosphere. Surrounded by a wealth of local attractions, our apartments are the ideal choice for comfortable and modern living in a prime location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Electric & Baseboard Heat Apartments in 80909",
      "seo_description": "Bristol Square offers electric and baseboard heat apartments in the 80909 area. Enjoy cozy living with modern amenities in East Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "bristol-square-modern-amenities-colorado-springs",
      "search_query": "Bristol Square modern amenities Colorado Springs",
      "category": "Amenity",
      "h1_title": "Bristol Square Modern Amenities Colorado Springs",
      "h2_subtitle": "Explore the modern amenities at Bristol Square in Colorado Springs. Experience convenience and comfort in this vibrant community.",
      "page_copy": "At Bristol Square, enjoy a host of modern amenities designed to enhance your lifestyle in beautiful Colorado Springs. Our community provides all the comforts of home, including practical features like efficient garbage disposal systems and energy-conscious electric and baseboard heating. \n\nLocated in East Colorado Springs, residents can revel in stylish living spaces that come with air conditioning and spacious linen closets, making organization a breeze. Bristol Square melds convenience with contemporary design, offering a harmonious living environment right in the heart of El Paso County. Discover what makes our property the perfect place for modern and comfortable living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Amenities at Bristol Square, Colorado Springs",
      "seo_description": "Discover Bristol Square's modern amenities in Colorado Springs. Enjoy comfort and style in a thriving community with great features like air conditioning and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "studio-apartments-east-colorado-springs-bristol",
      "search_query": "studio apartments east colorado springs",
      "category": "Floorplan",
      "h1_title": "Studio Apartments East Colorado Springs",
      "h2_subtitle": "Discover the charm of studio apartments at Bristol Square. Located in East Colorado Springs, these homes offer modern amenities in a vibrant community.",
      "page_copy": "Bristol Square presents stylish studio apartments nestled in the lively neighborhood of East Colorado Springs. Ideal for those seeking a compact yet well-equipped living space, our studio apartments are perfect for modern living with a touch of elegance and comfort.\n\nEach studio is thoughtfully designed with essential amenities such as garbage disposal, efficient electric and baseboard heating, and air conditioning. Enjoy ample storage with spacious linen closets, all within a community that blends convenience and vibrant city living. Situated at the heart of East Colorado Springs, Bristol Square offers more than just a home—it’s a gateway to the best that the area has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in East Colorado Springs",
      "seo_description": "Explore Bristol Square's studio apartments in East Colorado Springs. Modern amenities and vibrant living await you in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-colorado-springs-co-bristol",
      "search_query": "1 bedroom apartments colorado springs co",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments Colorado Springs, CO",
      "h2_subtitle": "Bristol Square offers cozy 1 bedroom apartments in Colorado Springs, CO. Enjoy modern amenities in a delightful community setting.",
      "page_copy": "Discover the comfort and convenience of 1 bedroom apartments at Bristol Square, situated in the vibrant city of Colorado Springs, CO. Each apartment is designed with contemporary living in mind, featuring essential amenities such as electric and baseboard heating, air conditioning, and efficient garbage disposal systems.\n\nLocated in East Colorado Springs, our community not only provides practical and elegant living spaces but also offers easy access to the city's numerous local attractions. The added benefit of a spacious linen closet makes storage effortless and enhances your living experience in our well-appointed apartments. Experience the perfect blend of modern amenities and a welcoming community atmosphere at Bristol Square.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Colorado Springs, CO",
      "seo_description": "Find 1 bedroom apartments at Bristol Square in Colorado Springs, CO. Enjoy modern amenities and a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-el-paso-county-bristol",
      "search_query": "2 bedroom apartments near el paso county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near El Paso County",
      "h2_subtitle": "Enjoy spacious 2 bedroom apartments at Bristol Square, conveniently located near El Paso County. Experience comfort and modern amenities.",
      "page_copy": "Bristol Square offers spacious 2 bedroom apartments near El Paso County, providing the perfect setting for a comfortable and modern lifestyle. Our thoughtfully designed homes feature essential amenities such as electric heating, garbage disposal, and air conditioning, ensuring a cozy and efficient living environment.\n\nNestled in East Colorado Springs, residents benefit from easy access to local attractions while enjoying the tranquility of a welcoming community. Each apartment includes a roomy linen closet, providing ample storage solutions. Discover the perfect blend of style and convenience at Bristol Square, where living near El Paso County enhances your way of life with modern amenities and community charm.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near El Paso County",
      "seo_description": "Discover comfortable and modern 2 bedroom apartments at Bristol Square, located conveniently near El Paso County in East Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "apartments-near-uccs-bristol-square",
      "search_query": "apartments near University of Colorado Colorado Springs",
      "category": "School",
      "h1_title": "Apartments Near University of Colorado Colorado Springs",
      "h2_subtitle": "Bristol Square offers ideal apartments near UCCS, providing modern amenities and a welcoming community atmosphere in East Colorado Springs.",
      "page_copy": "For those seeking convenient living near the University of Colorado Colorado Springs, Bristol Square is the perfect choice. Our apartments are located in East Colorado Springs, just a short drive from the university, making it an ideal spot for students and faculty.\n\nOur community features essential amenities including electric and baseboard heating, air conditioning, and garbage disposal systems, which ensure comfort throughout the year. Spacious linen closets provide ample storage, adding to the convenience of living at Bristol Square. Experience a vibrant community close to UCCS with Bristol Square's well-equipped and inviting apartment homes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Colorado Colorado Springs",
      "seo_description": "Find modern apartments at Bristol Square, near the University of Colorado Colorado Springs, offering convenient living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "apartments-close-to-colorado-college-east-cs",
      "search_query": "apartments close to Colorado College East Colorado Springs",
      "category": "School",
      "h1_title": "Apartments Close to Colorado College",
      "h2_subtitle": "Discover apartments close to Colorado College in East Colorado Springs at Bristol Square. Enjoy modern amenities and a prime location.",
      "page_copy": "Bristol Square is a top choice for those seeking apartments close to Colorado College in East Colorado Springs. Our community provides a comfortable living environment with all the essentials needed for a convenient lifestyle, including electric heating, air conditioning, and efficient garbage disposal.\n\nSituated in the heart of East Colorado Springs, residents of Bristol Square enjoy the benefits of being near Colorado College while experiencing the quiet charm of our welcoming community. The spacious linen closets offer additional storage, enhancing the appeal of our thoughtfully designed apartment homes. Find the perfect combination of proximity, amenities, and community spirit at Bristol Square.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Colorado College",
      "seo_description": "Explore Bristol Square's modern apartments close to Colorado College in East Colorado Springs, offering convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "apartments-near-uchealth-memorial-hospital-central",
      "search_query": "apartments near UCHealth Memorial Hospital Central Colorado Springs",
      "category": "Hospital",
      "h1_title": "Apartments Near UCHealth Memorial Hospital",
      "h2_subtitle": "Discover ideal living at Bristol Square, offering apartments near UCHealth Memorial Hospital Central in East Colorado Springs.",
      "page_copy": "For healthcare professionals, patients, or visitors seeking comfortable living arrangements, Bristol Square offers apartments conveniently near UCHealth Memorial Hospital Central in East Colorado Springs. These homes provide modern amenities such as air conditioning, garbage disposal, and baseboard heating, ensuring a comfortable lifestyle.\n\nSituated in East Colorado Springs, this community offers easy access to the hospital while providing a serene living environment. Enjoy spacious linen closets and a welcoming neighborhood atmosphere. At Bristol Square, you can enjoy the balance of proximity to essential facilities and the peace of a well-appointed home. Ideal for anyone connected to the hospital, Bristol Square provides a comforting and convenient home base.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UCHealth Memorial Hospital",
      "seo_description": "Find modern apartments at Bristol Square near UCHealth Memorial Hospital Central, offering convenience and comfort in East Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "bristol-square-near-commonspirit-penrose-hospital",
      "search_query": "Bristol Square apartments close to CommonSpirit Penrose Hospital",
      "category": "Hospital",
      "h1_title": "Bristol Square Apartments Near Penrose Hospital",
      "h2_subtitle": "Discover Bristol Square, offering apartments near CommonSpirit Penrose Hospital in East Colorado Springs, designed for comfort and convenience.",
      "page_copy": "Located in East Colorado Springs, Bristol Square provides a perfect home base for anyone working at or visiting CommonSpirit Penrose Hospital. Our apartments offer a range of modern amenities, including air conditioning and efficient garbage disposal, which ensure a comfortable stay year-round. \n\nWith a prime location close to Penrose Hospital, Bristol Square is the ideal choice for healthcare employees or those needing frequent hospital access. Spacious linen closets and baseboard heat add extra layers of convenience to everyday living. Experience a community where proximity to work and home comfort are perfectly balanced at Bristol Square.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bristol Square Apartments Near Penrose Hospital",
      "seo_description": "Explore Bristol Square's apartments near CommonSpirit Penrose Hospital in East Colorado Springs, combining convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "apartments-near-garden-of-the-gods-cos",
      "search_query": "apartments near garden of the gods colorado springs",
      "category": "Park",
      "h1_title": "Apartments Near Garden of the Gods",
      "h2_subtitle": "Find your ideal home at Bristol Square, offering apartments near the stunning Garden of the Gods in Colorado Springs.",
      "page_copy": "Experience the natural beauty of Colorado Springs by living at Bristol Square, where our apartments provide easy access to the iconic Garden of the Gods. Located in East Colorado Springs, our community is perfect for outdoor enthusiasts who want to enjoy the park's stunning rock formations and trails.\n\nOur apartments feature modern amenities including air conditioning, garbage disposal, and spacious linen closets, making them an excellent option for those seeking comfort and practicality. The tranquil setting of Bristol Square, combined with its proximity to the Garden of the Gods, offers residents a unique blend of adventure and relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Garden of the Gods",
      "seo_description": "Discover Bristol Square's convenient apartments near Garden of the Gods in Colorado Springs, offering comfort and access to natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "rentals-near-memorial-park-el-paso-county",
      "search_query": "rentals near memorial park el paso county",
      "category": "Park",
      "h1_title": "Rentals Near Memorial Park El Paso County",
      "h2_subtitle": "Explore comfortable living at Bristol Square, offering rentals near Memorial Park in El Paso County, Colorado Springs.",
      "page_copy": "Situated in East Colorado Springs, Bristol Square offers ideal rentals for those seeking proximity to Memorial Park in El Paso County. Our community ensures a comfortable lifestyle with amenities like air conditioning and garbage disposal, perfect for renters who value convenience.\n\nBeing near Memorial Park, residents can enjoy easy access to outdoor activities, including trails, sports facilities, and scenic picnics. At Bristol Square, spacious linen closets and efficient baseboard heating enhance daily living, making it an excellent choice for those who appreciate comfort and an active lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Memorial Park El Paso County",
      "seo_description": "Check out Bristol Square's rentals near Memorial Park in El Paso County, Colorado Springs, offering comfort and easy access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "living-near-palmer-park-east-colorado-springs",
      "search_query": "living near palmer park east colorado springs",
      "category": "Park",
      "h1_title": "Living Near Palmer Park",
      "h2_subtitle": "Discover Bristol Square's charm. Experience living near Palmer Park in East Colorado Springs, perfect for nature lovers and urban conveniences.",
      "page_copy": "At Bristol Square, enjoy the best of both worlds by living near Palmer Park in East Colorado Springs. Our vibrant community is ideal for those who love the great outdoors while appreciating urban amenities. Located close to Palmer Park, our apartments offer convenient access to beautiful trails and recreational activities.\n\nApartment living at Bristol Square means enjoying modern comforts such as air conditioning, garbage disposal, and ample linen closet space, enhancing daily life. Residents relish the combination of nearby natural beauty and essential on-site amenities, making Bristol Square a top choice for living near Palmer Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Palmer Park, East Colorado Springs",
      "seo_description": "Experience the best of both worlds at Bristol Square, living near Palmer Park in East Colorado Springs with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167178",
      "source": "generator",
      "page_item_url": "apartments-close-to-cottonwood-creek-park-80909",
      "search_query": "apartments close to cottonwood creek park 80909",
      "category": "Park",
      "h1_title": "Apartments Close to Cottonwood Creek Park",
      "h2_subtitle": "Enjoy life at Bristol Square, offering apartments close to Cottonwood Creek Park in the 80909 area, where nature meets urban comfort.",
      "page_copy": "Bristol Square is the perfect place for those seeking apartments close to Cottonwood Creek Park in the 80909 zip code. Our community is nestled in East Colorado Springs, providing residents with easy access to the beautiful landscapes and recreational opportunities at Cottonwood Creek Park.\n\nOur apartments feature essential comforts such as air conditioning, a convenient garbage disposal, and spacious linen closets. Living at Bristol Square means you can enjoy nearby park trails and community amenities while appreciating a comfortable base with modern conveniences in a prime location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Cottonwood Creek Park",
      "seo_description": "Discover comfort at Bristol Square, apartments near Cottonwood Creek Park in 80909, offering convenience and access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309442314"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263524"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WRHC3C5K"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a2130b32-ee23-4add-8ea0-2fc49e769459/app.js?property=a2130b32-ee23-4add-8ea0-2fc49e769459&propertyName=Bristol+Square&channelUuid=c248e9e2-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47611881616"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Iisva2dyVGk1Q0xxREVweGNMZktZUVE9PSIsInZhbHVlIjoiY3lGM1g4SXMrSzUxREdsVEFTaFZWdz09IiwibWFjIjoiOWU4MTdhNWZkOGNkODZlOGVlNzU1MzgwMWNkMmQxMzAxODMxNDU3MTAxZWJjZjI3N2Q1ZTY0NTJmZTAyMTNlZiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309442314",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263524",
  "custom_google_gtm_id": "GTM-WRHC3C5K",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a2130b32-ee23-4add-8ea0-2fc49e769459/app.js?property=a2130b32-ee23-4add-8ea0-2fc49e769459&propertyName=Bristol+Square&channelUuid=c248e9e2-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47611881616",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Iisva2dyVGk1Q0xxREVweGNMZktZUVE9PSIsInZhbHVlIjoiY3lGM1g4SXMrSzUxREdsVEFTaFZWdz09IiwibWFjIjoiOWU4MTdhNWZkOGNkODZlOGVlNzU1MzgwMWNkMmQxMzAxODMxNDU3MTAxZWJjZjI3N2Q1ZTY0NTJmZTAyMTNlZiJ9",
  "custom_audioeye_site_id": "763ed635-6e1e-45b0-ac7b-9fa4d8e9ac2f",
  "custom_audioeye_site_hash": "e476ef31f1340fd7d9771d6a34007edc"
};

export const generatedAt = '2026-11-02T22:22:17.383Z';
